import { render } from "./ChartWrap.vue?vue&type=template&id=bad1c576"
import script from "./ChartWrap.vue?vue&type=script&lang=js"
export * from "./ChartWrap.vue?vue&type=script&lang=js"

import "./ChartWrap.vue?vue&type=style&index=0&id=bad1c576&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__